import { useContext } from "react";
import { AuthContext } from "./AuthProvider";

/**
 * Hace uso de use context para devolver el contexto
 * @returns AuthContext
 */
export default function useAuth() {
    return useContext(AuthContext);
}